/* global clearTimeout */
import { useState, useEffect, useMemo } from "react";

import { GET_PARAMS } from "../const/router";
import useGetParameter from "../hooks/useGetParameter";

let timeout: any;

function parseStringifiedValue(value: any) {
    return value ? value.split(",") : [];
}

export default function useGetPopupsState() {
    const rawPopups = useGetParameter(GET_PARAMS.popup);
    const [mountedPopups, setMountedPopups] = useState(
        parseStringifiedValue(rawPopups)
    );

    useEffect(() => {
        if (rawPopups) {
            timeout && clearTimeout(timeout);
            setMountedPopups(rawPopups.split(","));
        } else {
            timeout = setTimeout(() => {
                setMountedPopups([]);
            }, 300);
        }
    }, [rawPopups]);

    useEffect(() => {
        return () => {
            timeout && clearTimeout(timeout);
        };
    }, []);

    const popups = useMemo(() => parseStringifiedValue(rawPopups), [rawPopups]);

    return {
        mountedPopups,
        popups,
    };
};